<template>
    <div class="image-upload">
        <img v-if="img && !pastedImg" :src="img" />
        <img v-if="pastedImg" :src="pastedImg" />
        <input
            ref="fileInput"
            :name="name"
            type="file"
            accept="image/png, image/jpeg"
            @change="handleFileChange($event)"
        />
    </div>
</template>
<script>
export default {
    name: "ImageUpload",
    props: {
        img: {
            type: String,
            default: null,
        },
        name: {
            type: String,
            default: null,
        },
        modelValue: {
            type: Object,
            default: null,
        },
    },
    emits: ["update:modelValue"],
    data() {
        return {
            pastedImg: null,
        };
    },
    watch: {
        modelValue(newValue) {
            if (!newValue) {
                this.pastedImg = null;
                if (this.$refs.fileInput) {
                    this.$refs.fileInput.value = "";
                }
            }
        },
    },
    mounted() {
        window.addEventListener("paste", this.getImageFromClipboard);
    },
    beforeUnmount() {
        window.removeEventListener("paste", this.getImageFromClipboard);
    },
    methods: {
        getFileDataUrl(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => resolve(reader.result);
                reader.onerror = (error) => reject(error);
                reader.readAsDataURL(file);
            });
        },
        getImageFromClipboard(e) {
            let items =
                (e.clipboardData || e.originalEvent.clipboardData || {})
                    .items || [];
            for (var i = 0; i < items.length; i++) {
                var item = items[i];
                if (
                    item.type === "image/png" ||
                    item.type === "image/jpeg" ||
                    item.type === "image/webp"
                ) {
                    let file = item.getAsFile();
                    this.getFileDataUrl(file).then((url) => {
                        this.pastedImg = url;
                    });
                    this.$emit("update:modelValue", file);
                    return;
                }
            }
        },
        handleFileChange(e) {
            const file = (e.target.files.length && e.target.files[0]) || null;
            if (file) {
                this.getFileDataUrl(file).then((url) => {
                    this.pastedImg = url;
                });
            } else {
                this.pastedImg = null;
            }
            this.$emit("update:modelValue", file);
        },
    },
};
</script>
